<script setup lang="ts">
import SimulationsDataTable from '@/features/matching/data-tables/SimulationsDataTable.vue'

definePage({
  path: '/matching/simulations',
  name: '/matching/Simulations',
  meta: {
    title: 'Simulaties',
    permission: {
      resource: 'Simulations',
      level: 'Read',
    },
  },
})
</script>

<template>
  <div class="space-y-5">
    <SimulationsDataTable />
  </div>
</template>
